import axios from 'axios'
import store from './../store'
import router from './../router'

axios.defaults.baseURL= process.env.VUE_APP_RUTA_API;
//axios.defaults.baseURL="http://192.168.1.139:5000/";
//axios.defaults.baseURL="http://192.168.1.235:45455/";

axios.interceptors.request.use(function (config) {
    //console.log(config)

    if(store.state.token && !config.url.includes("api/timezone")){
        config.headers.Authorization =  'Bearer ' + store.state.token;
    }

    return config;
});

axios.interceptors.response.use(
    response => response,
    error => {
        try{
            if (error.config.url == '/api/auth/refresh' || error.response.status == 401) {
                store.dispatch('logout')
                router.push({name : 'Login'})
            }
        }catch(error){
            //console.log(error)
        }
        return Promise.reject(error)
});

